import React from 'react';
import SectionTitle from './common/SectionTitle';
import TestimonialCard from './common/TestimonialCard';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "SellWise360 has transformed our inventory management. We've reduced stockouts by 80% and improved delivery times significantly.",
      author: "Opeyemi Oguntayo",
      position: "Operations Manager",
      company: "Solento Distributors"
    },
    {
      id: 2,
      text: "The MSP mobile app has revolutionized our field sales. Our reps now process 3x more orders per day with fewer errors.",
      author: "Ibem Anthony",
      position: "Sales Director",
      company: "Telex Pharm & Supplies"
    },
    {
      id: 3,
      text: "After implementing SellWise360 DMS, our order processing time decreased from 4 hours to just 30 minutes daily. Game changer!",
      author: "Calistus Idemudia",
      position: "CEO",
      company: "Calis Stores Ltd"
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <SectionTitle 
          title="What Our Clients Say"
          subtitle="Hear from distributors who have experienced the SellWise360 difference"
        />
        <div className="testimonial-grid">
          {testimonials.map(testimonial => (
            <TestimonialCard 
              key={testimonial.id}
              text={testimonial.text}
              author={testimonial.author}
              position={testimonial.position}
              company={testimonial.company}
            />
          ))}
        </div>
      </div><br/><br/>
    </section>
  );
};

export default Testimonials;